import React, { useState } from "react";
import {
	Button,
	Col,
	Divider,
	Flex,
	Form,
	Input,
	InputNumber,
	Modal,
	notification,
	Radio,
	Row,
	Select,
	Typography,
	DatePicker,
	Checkbox,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import dayjs from "dayjs";
import {
	jobPourOptions,
	jobTypeOptions,
	slumpOptions,
} from "../../constants/Job";
import { cityList } from "../utils/CityList";
import AddressGeolocation2 from "../map/AddressGeolocation2";
import { paymentTypeOptions } from "../../constants/Customer";
import { CustomSpinner } from "../utils/CustomComponents";

const { Title } = Typography;

const PreJobToJob = ({ preJobId, pcb }) => {
	const [loading, setLoading] = useState(true);
	const [loadingComponents, setLoadingComponents] = useState(true);
	const [loadingCustomer, setLoadingCustomer] = useState(true);
	const [loadingSeller, setLoadingSeller] = useState(true);
	const [loadingPsi, setLoadingPsi] = useState(true);
	const [loadingPlant, setLoadingPlant] = useState(true);
	const [loadingForeman, setLoadingForeman] = useState(true);
	const [dateMax, setDateMax] = useState(dayjs());
	const [minDateScheduledDate, setMinDateScheduledDate] = useState(dayjs());
	const [sellers, setSellers] = useState([]);
	const [customers, setCustomers] = useState([]);
	const [psi, setPsi] = useState([]);
	const [plants, setPlants] = useState([]);
	const [foremans, setForemans] = useState([]);
	const [initialValues, setInitialValues] = useState({
		fuelSurchargeGlobal: false,
		shippingGlobal: false,
		deliveryFee: 0,
		fuelSurcharge: 0,
		qualityControl: false,
		fiberQuantity: 0,
		prefix: "+1",
		taxExemptJob: false,
		hotShot: false,
	});
	const [openSearchAddressModal, setOpenSearchAddressModal] = useState(false);
	const [minPrice, setMinPrice] = useState(0);
	const [form] = Form.useForm();

	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getAllSelectValues();
	}, []);

	const getAllSelectValues = async () => {
		await Promise.all([
			getCustomers(),
			getSellers(),
			getPsi(),
			getPlants(),
			getForemans(),
			getJobId(),
		]).then(async (values) => {
			setLoadingComponents(false);
			getPREJob(
				values[0],
				values[1],
				values[2],
				values[3],
				values[4],
				values[5]
			);
			setLoading(false);
		});
	};

	const getPREJob = async (
		customers,
		sellers,
		psis,
		plants,
		foremans,
		jobNumber
	) => {
		try {
			const url = api + `/prejob/get/${preJobId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				const payload = data.payload;

				const regexCustomer = new RegExp(payload.customer, "i");
				const matchCustomer = customers.find((item) =>
					regexCustomer.test(item.label)
				);

				if (matchCustomer === undefined) {
					openNotification("warning", "Warning", "Customer on PRE not found");
				}

				const matchSeller = sellers.find(
					(item) => item.value === payload.sellerId
				);

				if (matchSeller === undefined) {
					openNotification("warning", "Warning", "Seller on PRE not found");
				}

				const regexPsi = new RegExp(payload.mix, "i");
				let matchPsi = psis.find((item) => regexPsi.test(item.label));

				if (matchPsi === undefined) {
					openNotification("warning", "Warning", "PSI on PRE not found");
				} else {
					matchPsi = matchPsi.disabled ? undefined : matchPsi;
				}

				const regexPlant = new RegExp(payload.plant, "i");
				const matchPlant = plants.find((item) => regexPlant.test(item.label));

				if (matchPlant === undefined) {
					openNotification("warning", "Warning", "Plant on PRE not found");
				}

				const regexForeman = new RegExp(payload.foreman, "i");
				const matchForeman = foremans.find((item) =>
					regexForeman.test(item.label)
				);

				if (matchForeman === undefined) {
					openNotification("warning", "Warning", "Foreman on PRE not found");
				}

				setInitialValues((prev) => ({
					...prev,
					userPRE: payload.user,
					customerPRE: payload.customer,
					targetYD3PRE: payload.targetYD3,
					pricePRE: payload.price,
					mixPRE: payload.mix,
					foremanPRE: payload.foreman,
					slumpPRE: payload.slump,
					plantPRE: payload.plant,
					customerShipAddressPRE: payload.customerShipAddress,
					//
					customer: matchCustomer ? matchCustomer.value : undefined,
					paymentType: matchCustomer
						? matchCustomer.value.split(",")[1]
						: undefined,
					paymentTerm: matchCustomer
						? matchCustomer.value.split(",")[2] !== "undefined"
							? matchCustomer.value.split(",")[2]
							: undefined
						: undefined,

					seller: matchSeller ? matchSeller.value : undefined,
					psi: matchPsi ? matchPsi.value : undefined,
					psiId: matchPsi ? matchPsi.value.split(",")[0] : undefined,
					psiName: matchPsi ? matchPsi.label : undefined,
					unitPrice: payload.price,
					taxPrice: payload.price * 1.0825,
					plant: matchPlant ? matchPlant.value : undefined,
					customerShipAddress: payload.customerShipAddress,
					foremanPhone: matchForeman
						? matchForeman.value.split(",")[2].slice(2)
						: undefined,
					jobForeman: matchForeman
						? matchForeman.value.split(",")[1]
						: undefined,
					foreman: matchForeman ? matchForeman.value.split(",")[0] : undefined,
					foremanItem: matchForeman ? matchForeman.value : undefined,
					targetYD3: payload.targetYD3,
					slump:
						payload.slump >= 3 && payload.slump <= 9
							? payload.slump
							: undefined,
					number: jobNumber,
					scheduledDate: dayjs(payload.scheduledDate),
					inspectionTimeStamp: dayjs(payload.scheduledDate),
				}));

				setMinPrice(matchPsi ? Number(matchPsi.value.split(",")[2]) : 0);
				setMinDateScheduledDate(dayjs(payload.scheduledDate));
				setDateMax(dayjs(new Date(payload.scheduledDate)));
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get PRE Job");
			console.error(err.message);
			return null;
		}
	};

	const getJobId = async () => {
		const url = api + "/jobid";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			return data.jobId;
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getCustomers = async () => {
		const url = api + `/customer/franchise/available/57Concrete`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				const payload = data.payload;
				let list = [];
				payload.map((item) => {
					list.push({
						label: `${item.customerNumber} ${item.name}`,
						value: `${item._id},${item.paymentType},${item.paymentTerm}`,
					});
				});
				setCustomers(list);
				setLoadingCustomer(false);
				return list;
			} else {
				openNotification("error", "Error", data.message);
				return null;
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getSellers = async () => {
		const url = api + `/user/list/57Concrete/Seller`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				const payload = data.payload;
				let list = [];
				payload.map((item) => {
					list.push({
						label: item.name,
						value: item._id,
					});
				});
				setSellers(list);
				setLoadingSeller(false);
				return list;
			} else {
				openNotification("error", "Error", data.message);
				return null;
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getPsi = async () => {
		const url = api + `/psi/list/57Concrete`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];

			data.map((item) => {
				list.push({
					value: `${item._id},${item.price},${item.minPrice || 0}`,
					label: item.psi,
					disabled: !item.active,
				});
			});
			setPsi(list);
			setLoadingPsi(false);
			return list;
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getPlants = async () => {
		const url = api + `/plant/list/57Concrete`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				const payload = data.payload;
				let list = [];
				payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setPlants(list);
				setLoadingPlant(false);
				return list;
			} else {
				openNotification("error", "Error", data.message);
				return null;
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getForemans = async () => {
		const url = api + `/foreman/list/57Concrete`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			const optionsAux = [];
			data.forEach((foreman) => {
				let value = `${foreman._id},${foreman.firstName} ${foreman.lastName},${foreman.phone}`;
				let aux = `${foreman.firstName} ${foreman.lastName}`;
				let label = aux.toUpperCase();
				let obj = {
					value: value,
					label: label,
				};
				if (foreman.active) optionsAux.push(obj);
			});
			setForemans(optionsAux);
			setLoadingForeman(false);
			return optionsAux;
		} catch (err) {
			console.error(err);
			return null;
		}
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const onChangePsi = (selectedPsi) => {
		if (selectedPsi) {
			let values = selectedPsi.value.split(",");
			form.setFieldsValue({
				psiPrice: values[1],
				unitPrice: values[1],
				taxPrice: values[1] * 1.0825,
				psiName: selectedPsi.label,
				psi: selectedPsi.value,
				psiId: values[0],
			});
			setMinPrice(Number(values[2]));
		}
	};

	const onChangeCity = (selectedCity) => {
		if (selectedCity) {
			form.setFieldValue("shipCity", selectedCity.value);
			form.setFieldValue("city", selectedCity.label);
		}
	};

	const handleSearchAddressCancel = () => {
		setOpenSearchAddressModal(false);
	};

	const handleSearchAddressOpen = () => {
		setOpenSearchAddressModal(true);
	};

	const handleCallback = (childData) => {
		form.setFieldsValue({
			shipAddress: childData.address,
			destinationTime: childData.duration,
			distance: childData.distance,
			latitude: childData.destLat,
			longitude: childData.destLng,
			shipCity: childData.locality
				? childData.locality.toLowerCase()
				: undefined,
		});
		handleSearchAddressCancel();

		let cityFound = cityList.find((city) => city.label === childData.locality);
		if (typeof cityFound !== "undefined") {
			form.setFieldValue("city", childData.locality);
		} else {
			form.setFieldValue("city", undefined);
			form.setFieldValue("shipCity", undefined);
			openNotification(
				"warning",
				"Warning",
				`The city ${childData.locality} is not defined in list, please select it from city options to save it.`
			);
		}
	};

	const RenderSearchAddressModal = () => {
		return (
			<Modal
				title="Address"
				open={openSearchAddressModal}
				onCancel={handleSearchAddressCancel}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={600}
			>
				<AddressGeolocation2
					search={true}
					parentCallback={handleCallback}
					single={false}
					plant={form.getFieldValue("plant")}
					currentLocation={false}
				/>
			</Modal>
		);
	};

	const prefixSelector = (
		<Form.Item name="prefix" noStyle>
			<Select
				style={{
					width: 70,
				}}
			>
				<Select.Option value="+1">+1</Select.Option>
			</Select>
		</Form.Item>
	);

	const onChangeForeman = (selectedForeman) => {
		if (selectedForeman) {
			let option = selectedForeman.split(",");
			let foremanID = option[0];
			let foremanName = option[1];
			let foremanPhone = option[2];
			form.setFieldsValue({
				foremanPhone: foremanPhone.slice(2),
				jobForeman: foremanName,
				foreman: foremanID,
			});
		}
	};

	const range = (start, end) => {
		const result = [];
		for (let i = start; i < end; i++) {
			result.push(i);
		}
		return result;
	};

	const onChangeDate = (value) => {
		setDateMax(value);
		form.setFieldValue("scheduledDate", value);
	};

	const disabledDateTime = (date) => {
		const scheduledDateDay = dayjs(dateMax).day();
		const currentDateDay = dayjs(date).day();
		if (scheduledDateDay === currentDateDay) {
			const scheduledDateMinute = dayjs(dateMax).minute();
			const scheduledDateHour = dayjs(dateMax).hour() + 1;
			return {
				disabledMinutes: () => range(scheduledDateMinute, 60),
				disabledHours: () => range(scheduledDateHour, 24),
			};
		} else {
			return {
				disabledMinutes: () => [],
				disabledHours: () => [],
			};
		}
	};

	const onChangeUnitPrice = (value) => {
		if (value !== null || value !== undefined) {
			if (value >= 0 && value <= 2000) {
				form.setFieldValue("taxPrice", value * 1.0825);
			}
		} else {
			form.setFieldValue("taxPrice", 0);
		}
	};

	const createJob = async () => {
		const values = form.getFieldsValue(true);

		const job = {
			number: values.number,
			firstShipmentDate: new Date(),
			approved: values.paymentType === "Credit" ? true : false,
			customer: values.customer.split(",")[0],
			paymentType: values.paymentType,
			seller: values.seller,
			jobType: values.jobType,
			jobPoor: values.jobPoor,
			psi: values.psiName,
			psiId: values.psiId,
			plant: values.plant,
			shipAddress: values.shipAddress,
			customerShipAddress: values.customerShipAddress,
			shipCity: values.city,
			destinationTime: values.destinationTime,
			distance: values.distance,
			latitude: values.latitude,
			longitude: values.longitude,
			foreman: values.foreman,
			jobForeman: values.jobForeman,
			foremanPhone: "+1" + values.foremanPhone,
			taxExemptJob: values.taxExemptJob,
			targetYD3: values.targetYD3,
			balance: values.balance,
			jobDuration: values.jobDuration,
			scheduledDate: dayjs(values.scheduledDate).toDate(),
			inspectionTimeStamp: dayjs(values.inspectionTimeStamp).toDate(),
			fiberQuantity: values.fiberQuantity || 0,
			unitPrice: values.unitPrice,
			paid: false,
			fuelSurchargeGlobal: values.fuelSurchargeGlobal,
			shippingGlobal: values.shippingGlobal,
			fuelSurcharge: values.fuelSurcharge || 0,
			deliveryFee: values.deliveryFee || 0,
			comments: values.comments || undefined,
			slump: values.slump,
			qualityControl: values.qualityControl,
			paymentTerm: values.paymentTerm,
			estimatedTime: values.estimatedTime,
			hotShot: values.hotShot,
			createdBy: localStorage.getItem("userId"),
			updatedBy: localStorage.getItem("userId"),
			franchise: "57Concrete",
			loadYD3: 0,
			jobStatusHistory: [
				{
					user: localStorage.getItem("userId"),
					jobStatus: "New Order",
				},
			],
		};

		const url = api + "/job";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.post(url, job);
			setLoadingComponents(false);
			pcb(data._id);
		} catch (err) {
			openNotification("error", "Error", "Cannot get job details");
			setLoadingComponents(false);
			console.error(err.message);
			return null;
		}
	};

	const onChangeCustomer = (selectedCustomer) => {
		if (selectedCustomer) {
			const values = selectedCustomer.split(",");
			form.setFieldValue("paymentType", values[1] || "");
			form.setFieldValue(
				"paymentTerm",
				values[2] === "undefined" ? "" : values[2]
			);
		}
	};

	const onChangeHotShot = (e) => {
		const checked = e.target.checked;
		if (checked) {
			setMinDateScheduledDate(dayjs());
			form.setFieldValue("scheduledDate", dayjs());
			setDateMax(dayjs());
		} else {
			setMinDateScheduledDate(
				dayjs(new Date(form.getFieldValue("scheduledDate"))).add(36, "hour")
			);
			form.setFieldValue("scheduledDate", dayjs().add(36, "hour"));
			setDateMax(dayjs(form.getFieldValue("scheduledDate")));
		}
	};

	const onFinish = async () => {
		setLoadingComponents(true);
		createJob();
	};

	const RenderForm = () => (
		<Form
			form={form}
			layout="vertical"
			initialValues={initialValues}
			onFinish={onFinish}
		>
			<Title level={3}>PRE Job Data</Title>
			<Row gutter={16}>
				<Col span={8}>
					<Form.Item
						label="User"
						name="userPRE"
						rules={[
							{ type: "email", message: "Email is invalid" },
							{ required: true, message: "User is required" },
						]}
					>
						<Input size="large" readOnly={true} />
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						label="Customer"
						name="customerPRE"
						rules={[{ required: true, message: "Customer is required" }]}
					>
						<Input size="large" readOnly={true} />
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						label="Target YD3"
						name="targetYD3PRE"
						rules={[{ required: true, message: "Target YD3 is required" }]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							readOnly={true}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
						/>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						label="Price"
						name="pricePRE"
						rules={[{ required: true, message: "Price is required" }]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							readOnly={true}
							formatter={(value) =>
								`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
						/>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						label="Mix"
						name="mixPRE"
						rules={[{ required: true, message: "Mix is required" }]}
					>
						<Input size="large" readOnly={true} />
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						label="Foreman"
						name="foremanPRE"
						rules={[{ required: true, message: "Foreman is required" }]}
					>
						<Input size="large" readOnly={true} />
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						label="Slump"
						name="slumpPRE"
						rules={[{ required: true, message: "Slump is required" }]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select slump"
							options={slumpOptions}
							optionFilterProp="children"
							disabled={true}
						/>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						label="Plant"
						name="plantPRE"
						rules={[{ required: true, message: "Plant is required" }]}
					>
						<Input size="large" readOnly={true} />
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						label="Customer Shipping Address"
						name="customerShipAddressPRE"
						rules={[
							{
								required: true,
								message: "Customer Shipping Address is required",
							},
						]}
					>
						<Input size="large" readOnly={true} />
					</Form.Item>
				</Col>
			</Row>
			<Divider />
			<Row gutter={16}>
				<Col span={24}>
					<Form.Item label="Job ID" name="number">
						<Input size="large" disabled />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16} align={"middle"}>
				<Col span={24} md={12}>
					<Form.Item
						label="Customer"
						name="customer"
						rules={[
							{
								required: true,
								message: "Please select a customer",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select a customer"
							loading={loadingComponents || loadingCustomer}
							options={customers}
							onChange={onChangeCustomer}
							showSearch
							disabled={loadingComponents || loadingCustomer}
							optionFilterProp="children"
							filterOption={filterOption}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item
						label="Seller"
						name="seller"
						rules={[
							{
								required: true,
								message: "Please select a seller",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select seller"
							options={sellers}
							disabled={
								loadingComponents ||
								loadingSeller ||
								!(
									localStorage.getItem("role") === "Admin" ||
									localStorage.getItem("email") === "rl@57concrete.com" ||
									localStorage.getItem("email") === "ec@57concrete.com" ||
									localStorage.getItem("email") === "pc@57concrete.com" ||
									localStorage.getItem("email") === "jc@57concrete.com" ||
									localStorage.getItem("email") === "gg@57xgroup.com" ||
									localStorage.getItem("email") === "jh@57concrete.com" ||
									localStorage.getItem("email") === "eliud@gmail.com"
								)
							}
							loading={loadingComponents || loadingSeller}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} md={12}>
					<Form.Item
						label="Job Type"
						name="jobType"
						rules={[
							{
								required: true,
								message: "Please select job type",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select job type"
							options={jobTypeOptions}
							disabled={loadingComponents}
							loading={loadingComponents}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item
						label="Job Pour"
						name="jobPoor"
						rules={[
							{
								required: true,
								message: "Please select job pour",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select job pour"
							options={jobPourOptions}
							disabled={loadingComponents}
							loading={loadingComponents}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} md={12}>
					<Form.Item
						label="Psi"
						name="psi"
						rules={[
							{
								required: true,
								message: "Please select a psi",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select a psi"
							options={psi}
							disabled={loadingComponents || loadingPsi}
							loading={loadingComponents || loadingPsi}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
							labelInValue
							onChange={onChangePsi}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item
						label="Plant"
						name="plant"
						rules={[
							{
								required: true,
								message: "Please select a plant",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select a plant"
							options={plants}
							disabled={loadingComponents || loadingPlant}
							loading={loadingComponents || loadingPlant}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
						/>
					</Form.Item>
				</Col>
			</Row>
			<Divider />
			<Title level={3}>Ship to Address</Title>
			<Row gutter={16} align={"middle"}>
				<Col span={24} md={4}>
					<Button
						size="large"
						type="primary"
						htmlType="button"
						icon={<SearchOutlined />}
						style={{ width: "100%" }}
						onClick={handleSearchAddressOpen}
						disabled={loadingComponents}
						loading={loadingComponents}
					>
						Search Address
					</Button>
				</Col>
				<Col span={24} md={8}>
					<Form.Item
						label="Ship Address"
						name="shipAddress"
						rules={[
							{
								required: true,
								message: "Fill ship address",
							},
						]}
					>
						<Input size="large" disabled />
					</Form.Item>
				</Col>
				<Col span={24} md={8}>
					<Form.Item
						label="Customer Ship Address"
						name="customerShipAddress"
						rules={[
							{
								required: true,
								message: "Fill customer ship address",
							},
						]}
					>
						<Input size="large" disabled={loadingComponents} />
					</Form.Item>
				</Col>
				<Col span={24} md={4}>
					<Form.Item
						label="Ship City"
						name="shipCity"
						rules={[
							{
								required: true,
								message: "Please select a city",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select a city"
							options={cityList}
							disabled={loadingComponents}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
							labelInValue
							onChange={onChangeCity}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item label="Time to Destination" name="destinationTime">
						<Input size="large" disabled />
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item label="Distance" name="distance">
						<Input size="large" disabled />
					</Form.Item>
				</Col>
			</Row>
			<Divider />
			<Row gutter={16} align={"middle"}>
				<Col span={24} md={12}>
					<Form.Item
						label="Foreman"
						name="foremanItem"
						rules={[
							{
								required: true,
								message: "Please select a foreman",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select foreman"
							options={foremans}
							disabled={loadingComponents}
							loading={loadingForeman}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
							onChange={onChangeForeman}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item label="Foreman Phone" name="foremanPhone">
						<Input size="large" addonBefore={prefixSelector} disabled />
					</Form.Item>
				</Col>
			</Row>

			<Row gutter={16}>
				<Col span={8}>
					<Form.Item name="taxExemptJob" label="Tax Exempt Job">
						<Radio.Group
							size="large"
							disabled={loadingComponents}
							buttonStyle="solid"
						>
							<Radio.Button value={true}>Yes</Radio.Button>
							<Radio.Button value={false}>No</Radio.Button>
						</Radio.Group>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item label="Payment Type" name="paymentType">
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select payment type"
							options={paymentTypeOptions}
							disabled
							optionFilterProp="children"
						/>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item label="Payment Term" name="paymentTerm">
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select payment type"
							options={paymentTypeOptions}
							disabled
							optionFilterProp="children"
						/>
					</Form.Item>
				</Col>
			</Row>
			<Divider />
			<Row gutter={16}>
				<Col span={8}>
					<Form.Item
						label="Target YD3"
						name="targetYD3"
						rules={[
							{
								required: true,
								message: "Please fill target",
							},
						]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item label="Balance" name="balance">
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item label="Job Duration" name="jobDuration">
						<Input size="large" disabled={loadingComponents} />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} md={8}>
					<Form.Item
						name="scheduledDate"
						label="Job date/time"
						rules={[
							{
								required: true,
								message: "Scheduled Date is required",
							},
						]}
					>
						<DatePicker
							style={{ width: "100%" }}
							size="large"
							showTime={{ format: "HH:mm" }}
							format="MM/DD/YYYY HH:mm A"
							allowClear={false}
							onChange={onChangeDate}
							disabled={loadingComponents}
							minDate={minDateScheduledDate}
						/>
					</Form.Item>
				</Col>
				<Col span={24} md={8}>
					<Form.Item
						name="inspectionTimeStamp"
						label="Inspection date/time"
						rules={[
							{
								required: true,
								message: "Inspection Time Stamp is required",
							},
						]}
					>
						<DatePicker
							style={{ width: "100%" }}
							size="large"
							showTime={{ format: "HH:mm" }}
							format="MM/DD/YYYY HH:mm A"
							allowClear={false}
							maxDate={dateMax}
							disabledTime={disabledDateTime}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
				{(localStorage.getItem("email") === "eliud@gmail.com" ||
					localStorage.getItem("email") === "ec@57concrete.com" ||
					localStorage.getItem("email") === "pc@57concrete.com" ||
					localStorage.getItem("email") === "jc@57concrete.com" ||
					localStorage.getItem("email") === "gg@57xgroup.com" ||
					localStorage.getItem("email") === "mv@57concrete.com" ||
					localStorage.getItem("email") === "al@57concrete.com" ||
					localStorage.getItem("email") === "jp@57concrete.com" ||
					localStorage.getItem("email") === "bpa@57concrete.com" ||
					localStorage.getItem("email") === "bp@57concrete.com") && (
					<Col span={24} md={8}>
						<Form.Item name="estimatedTime" label="Estimated Time (minutes)">
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
								disabled={loadingComponents}
							/>
						</Form.Item>
					</Col>
				)}
			</Row>
			<Row gutter={16}>
				<Col span={24} md={8}>
					<Form.Item label="Hot Shot" name="hotShot" valuePropName="checked">
						<Checkbox onChange={onChangeHotShot}>Is Hot Shot?</Checkbox>
					</Form.Item>
				</Col>
				<Col span={24} md={8}>
					<Form.Item label="Fiber Quantity" name="fiberQuantity">
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} md={12}>
					<Form.Item
						label="Unit Price"
						name="unitPrice"
						rules={[
							{
								required: true,
								message: "Unit Price is required",
							},
							{
								validator: (_, value) => {
									if (value < minPrice) {
										return Promise.reject(
											new Error(`Unit Price must be greater than ${minPrice}`),
										);
									}
									return Promise.resolve();
								},
							},
						]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={loadingComponents}
							onChange={onChangeUnitPrice}
							precision={3}
						/>
					</Form.Item>
				</Col>

				<Col span={24} md={12}>
					<Form.Item
						label="Price with Tax"
						name="taxPrice"
						rules={[
							{
								required: true,
								message: "Price with Tax is required",
							},
						]}
					>
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled
							precision={3}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={4}>
					<Form.Item name="fuelSurchargeGlobal" valuePropName="checked">
						<Checkbox disabled={loadingComponents}>Apply To Global</Checkbox>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item label="Fuel Surcharge" name="fuelSurcharge">
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={4}>
					<Form.Item name="shippingGlobal" valuePropName="checked">
						<Checkbox disabled={loadingComponents}>Apply To Global</Checkbox>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item label="Shipping Fee" name="deliveryFee">
						<InputNumber
							size="large"
							style={{ width: "100%" }}
							formatter={(value) =>
								`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							}
							parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24}>
					<Form.Item label="Comments" name="comments">
						<Input size="large" disabled={loadingComponents} />
					</Form.Item>
				</Col>
				<Col span={24} md={12}>
					<Form.Item
						label="Slump"
						name="slump"
						rules={[
							{
								required: true,
								message: "Please select a slump",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							size="large"
							placeholder="Please select slump"
							options={slumpOptions}
							optionFilterProp="children"
							disabled={loadingComponents}
						/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						label="Quality Control"
						name="qualityControl"
						valuePropName="checked"
					>
						<Checkbox disabled={loadingComponents}>QC Inspection</Checkbox>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={[16, 8]}>
				<Col>
					<Button
						type="primary"
						htmlType="submit"
						size="large"
						loading={loadingComponents}
						disabled={loadingComponents}
					>
						Save
					</Button>
				</Col>
			</Row>
		</Form>
	);

	return (
		<Flex vertical gap={"large"}>
			{contextHolder}
			{loading ? <CustomSpinner /> : <RenderForm />}
			<RenderSearchAddressModal />
		</Flex>
	);
};

export default PreJobToJob;
